/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Type of visit assigned to the form
 * @export
 * @interface VisitType1
 */
export interface VisitType1 {
}

/**
 * Check if a given object implements the VisitType1 interface.
 */
export function instanceOfVisitType1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VisitType1FromJSON(json: any): VisitType1 {
    return VisitType1FromJSONTyped(json, false);
}

export function VisitType1FromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitType1 {
    return json;
}

export function VisitType1ToJSON(value?: VisitType1 | null): any {
    return value;
}

